"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FADE : STYLES --------------- ++++++++++ */


var _default = {
  fade: {
    background: "linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(255,255,255,0.95) 100%)",
    // for now using white as our fade but this should really accept a color to customize this
    width: '100%',
    height: (0, _index.pxToEm)(120),
    // height should be a customizable prop as well
    //marginTop: pxToEm(-120), // pulling this up over top of the item above it (this should really be extended to accept props that will change this behavior in case we need a top fade or something else)
    position: 'relative'
  }
};
exports.default = _default;